<template>
  <div class="tilda-wrapper">
    <p v-for="product in tilda.products" :key="product.name" class="tilda-info">
      &bull;&nbsp;{{ product.name }} - {{ parseInt(product.amount) / 100 | currency }}
      &#8381;&nbsp;{{ product.quantity > 1 ? 'x ' + product.quantity : '' }}
    </p>

    <div v-if="hasCustomFields" class="tilda-info overflown">
      <p
        v-for="(field, fieldIndex) in preparedCustomFields"
        :key="fieldIndex"
        class="overflown"
      >
        {{ field.name }}: {{ field.value }}
      </p>
    </div>

    <div v-if="hasTranId" class="tilda-info">
      <p>Код заявки: {{ tilda.techFields.tranid }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TildaView',
  props: {
    tilda: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasCustomFields() {
      if (!this.$validate.isObjectWithFields(this.tilda, ['customFields'])) {
        return false;
      }

      return this.$validate.isNotEmptyObject(this.tilda.customFields);
    },
    preparedCustomFields() {
      if (!this.hasCustomFields) {
        return [];
      }

      const customFieldList = Object.keys(this.tilda.customFields)
        .map(field => {
          return {
            name: field,
            value: this.tilda.customFields[field],
          };
        });

      return customFieldList;
    },
    hasTranId() {
      if (!this.$validate.isObjectWithFields(this.tilda.techFields, ['tranid'])) {
        return false;
      }

      return this.$validate.isNotEmptyString(this.tilda.techFields.tranid);
    },
  },
};
</script>

<style lang="sass" scoped>
  .tilda-info
    &:not(:first-child)
      margin-top: 10px

    p
      font-size: 14px
      line-height: 20px
      color: #212121

  .overflown
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>
